"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubdomainContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledSubdomainContainer = styled_components_1.default.div `
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 0 0 1px ${config_1.colors.huron};
  display: flex;
  justify-content: flex-end;
  padding: 0 10px;

  &:focus-within {
    box-shadow: 0 0 0 1px ${config_1.colors.blurple};
  }

  &.invalid {
    box-shadow: 0 0 0 1px ${config_1.colors.redError} !important;
  }
`;
